jQuery(function () {
  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(cb);
    else cb();
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  const isEditor =
    document.body.classList.contains("block-editor-page") ||
    document.body.classList.contains("wp-admin");

  domReady(() => {
    if (isEditor) return;
    whenGsapReady(() => {
      whenScrollReady(() => {
        initAssessmentToday();
      });
    });
  });

  function initAssessmentToday() {
    const blocks = document.querySelectorAll(".js-assessment-today");
    if (!blocks.length) return;

    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    blocks.forEach((block) => {
      const items = Array.from(
        block.querySelectorAll(".js-at-item"),
      ).filter(Boolean);
      const cards = Array.from(
        block.querySelectorAll(".js-at-card"),
      ).filter(Boolean);

      if (!items.length && !cards.length) return;

      if (reduceMotion) {
        if (items.length) gsap.set(items, { autoAlpha: 1, y: 0 });
        if (cards.length) gsap.set(cards, { autoAlpha: 1, y: 0, scale: 1 });
        return;
      }

      if (items.length) gsap.set(items, { autoAlpha: 0, y: 18 });
      if (cards.length)
        gsap.set(cards, { autoAlpha: 0, y: 12, scale: 0.99, clearProps: "transform" });

      const tlVars = {
        defaults: { ease: "power3.out", duration: 0.9 },
      };

      if (ScrollTrigger) {
        tlVars.scrollTrigger = {
          trigger: block,
          start: "top 78%",
          once: true,
          invalidateOnRefresh: true,
        };
      }

      const tl = gsap.timeline(tlVars);
      if (items.length) {
        tl.to(
          items,
          { autoAlpha: 1, y: 0, stagger: 0.08, clearProps: "transform" },
          0,
        );
      }
      if (cards.length) {
        tl.to(
          cards,
          { autoAlpha: 1, y: 0, scale: 1, stagger: 0.05, clearProps: "transform" },
          0.05,
        );
      }
    });
  }
});

